module.exports = " <div id=container> <nav-wrapper :menu=conf.menu></nav-wrapper> <header-wrapper :header=conf.header></header-wrapper> <div class=wrapper> <announce :conf=conf></announce> <vision :conf=conf></vision> <speaker :conf=conf></speaker> <session :conf=conf></session> <map :conf=conf></map> <sponsor :conf=conf></sponsor> <about :conf=conf></about> </div> <footer-wrapper></footer-wrapper> <modal :detail=detail :type=type></modal> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 54
 ** module chunks = 1
 **/